import { ApolloLink, HttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { NextPageContext } from 'next'

import { getIsomorphicXOrganizationSlugHeader, logLinkErrors } from './utils'

import { getIsomorphicCookie } from '~lib/helpers'

/**
 * Apollo http link to be used in public launch routes
 */
const publicLaunchHttpLink = new HttpLink({
  uri: `${process.env.NEXT_PUBLIC_API_HOST}/graphql`,
})

/**
 * Apollo error link to be used in public launch routes
 */
const publicLaunchErrorLink = onError((error) => {
  logLinkErrors(error)
})

/**
 * Create isomorphic (client side & server side) apollo link extened with headers required for public launch page
 */
export const createPublicLaunchIsomorphicAuthLink = (ctx: NextPageContext | undefined) => {
  return setContext((_, prevContext) => {
    const cookies = getIsomorphicCookie(ctx?.req)

    const organizationSlug = getIsomorphicXOrganizationSlugHeader(ctx)

    if (!organizationSlug) return prevContext

    return {
      ...prevContext,
      headers: {
        ...prevContext.headers,
        launchId: ctx?.query?.launchId || cookies.launchId,
        organizationSlug, // TODO rename to X-Organization-Slug
      },
    }
  })
}

/**
 * Creates public launch page apollo link to be used in public launch routes
 */
export const createPublicLaunchApolloLink = (ctx: NextPageContext | undefined) => {
  return ApolloLink.from([createPublicLaunchIsomorphicAuthLink(ctx), publicLaunchErrorLink, publicLaunchHttpLink])
}
